import React from 'react'
import { useHistory } from 'react-router-dom'

import LoginLayout from '../../layout/LoginLayout'


const LandingPage = () => {
  const history = useHistory()

  const onSignup = () => {
    history.push('/signup')
  }

  return (
    <LoginLayout>
      <div className="landing-page">
        <div className="page-content-left">
          <div className="content-title">Get Access to the Most Comprehensive Supplier Payment Data</div>
          <div className="content-note">A streamlined web app that helps you create and collaborate in real-time on supplier payment acceptance</div>
          <div className="content-btn">
            <button type="button" onClick={onSignup}>Create an account</button>
          </div>
        </div>
        <div className="page-content-right">

        </div>
      </div>
    </LoginLayout>
  )
}

export default LandingPage
